export default function ContainerGrid({ children, itemWidth = '350px' }) {
    return (
        <div className="container-grid" style={{
            gridTemplateColumns: `repeat(auto-fill, minmax(${itemWidth}, 1fr))`
        }}>
            { children }
        </div>
    )
}
